import { render, staticRenderFns } from "./Simulacoes.vue?vue&type=template&id=48b9eabb&scoped=true&"
import script from "./Simulacoes.vue?vue&type=script&lang=js&"
export * from "./Simulacoes.vue?vue&type=script&lang=js&"
import style0 from "./Simulacoes.vue?vue&type=style&index=0&id=48b9eabb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9eabb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VCard,VCol,VDivider,VRow,VTooltip})
